export default "__VITE_ASSET__DVX4lu7a__"